import React from 'react';
import { Button } from '@/components/shadcn/button';
import { Frame } from '@/types/location';
import { addToDemo } from '@/api/location';

interface Props {
  locationId: string;
  addedToDemo: string[];
  setAddedToDemo: React.Dispatch<React.SetStateAction<string[]>>;
  activeSequence: Frame[];
  activeFrameIndex: number;
}

export default function AddToDemo({
  locationId,
  addedToDemo,
  setAddedToDemo,
  activeSequence,
  activeFrameIndex,
}: Props) {
  const { sequence } = activeSequence[activeFrameIndex];

  const optimisticallyAddToDemo = async (
    locationId: string,
    sequence: string,
  ) => {
    addToDemo(locationId, sequence);
  };

  return (
    <Button
      variant={addedToDemo.includes(sequence) ? 'success' : 'destructive'}
      size={'sm'}
      disabled={addedToDemo.includes(sequence)}
      className="w-32"
      onClick={() => {
        setAddedToDemo(prev => [...prev, sequence]);
        optimisticallyAddToDemo(locationId, sequence);
      }}>
      {addedToDemo.includes(sequence) ? 'Live' : 'Not shown'}
    </Button>
  );
}
